import styled, { css, keyframes } from "styled-components";

const bold = css`
  font-family: "OurLexend-Bold", Helvetica, sans-serif;
  font-weight: normal;
`;

const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

export const Sheet = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  background: #f4f6fb;
  border-radius: 24px 24px 0 0;
  animation: ${slideUp} 0.2s ease-out;
`;

export const SheetHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  flex-shrink: 0;
`;

export const SheetTitle = styled.div`
  ${bold}
  font-size: 20px;
  line-height: 26px;
  letter-spacing: -0.01em;
  color: #293142;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  color: #9197a6;
  cursor: pointer;
`;

export const SheetBody = styled.div`
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 8px 16px 24px;
`;

export const DetailCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(28, 28, 28, 0.06);
  overflow: hidden;
`;

export const TitleBar = styled.div`
  padding: ${(props) => (props.hasTag ? "0 16px 12px" : "16px 16px 12px")};
  box-shadow: inset 0 -1px 0 #e6e9ef;
`;

export const DetailTitle = styled.div`
  ${bold}
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.01em;
  color: #293142;
`;

export const Estimated = styled.span`
  font-family: "OurLexend-Regular", Helvetica, sans-serif;
  font-size: 13px;
  letter-spacing: 0;
  color: #767c8f;
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
`;

export const DetailRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
  line-height: 16px;
  color: #293142;
`;

export const DetailLabel = styled.div`
  flex: 0 1 auto;
  max-width: 50%;
  font-size: 13px;
  line-height: 16px;
`;

export const DetailValue = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  flex: 1;
  min-width: 0;
  gap: 8px;
  font-size: 13px;
  line-height: 16px;
  text-align: right;
  word-break: break-word;
`;

export const BottomMessage = styled.div`
  font-size: 13px;
  line-height: 16px;
  color: #767c8f;
`;
